import React from "react";
import { useBaseComponent } from "../../../../base/base-component";
import { IData, IQualification, IQualificationFormModel, IState } from "./types/qualification.types";
import { message } from "antd";
import server from "../../../../server";
import { fetchData, fetchQualifications, modelMapper, viewMapper } from "./action/qualification.action";
import QualificationView from "./qualification.view";
import DataLoading from "../../../../common/loading-data";

interface IQualificationProps {
    employeeId: string;
    goToNextTab: () => void;
}

const Qualification = (props: IQualificationProps) => {
    const {state, updateState} = useBaseComponent<IQualificationProps, IState>(props, {
        initialState: () => ({
            // data: initialData,
            internal: {
                loading: false,
                currentTab: 0,
                isFormValid: true,
            },
            external: {
                qualifications: []
            }
        }),
        onInit: () => onInit()
    });

    async function onInit() {
        if (props.employeeId) {
            const qualifications: IQualification[] = await fetchQualifications()
            const data: IData = await fetchData(props.employeeId);
            console.log("Qualification Data: ", data.qualification)
            updateState('data', data);
            updateState('external.qualifications', qualifications);
        } else {
            message.error("Initialization failed: Employee ID not found!");
        }
    }

    async function onSubmit(data: IQualificationFormModel) {
            let payload = modelMapper(data);
            console.log("Qualification Details Payload: ", payload);
            await server.employee.qualification.update(props.employeeId, payload);
            message.success('Qualification details submitted successfully!');
            
    }

    return (
        state.data === undefined ? <DataLoading title="Qualification Details"/> :
            <QualificationView
                loading={state.internal.loading}
                viewModel={viewMapper(state.data)}
                onSubmit={onSubmit}
                goToNextTab={props.goToNextTab}
                qualifications={state.external.qualifications}
                employeeId={props.employeeId}
            />
    )
}

export default Qualification;
